import { CrownMark } from "./CrownMark";
import { responsive, WIDE_WIDTHS } from "../lib/img";

// Editorial "showcase" figure: breaks out of the text column on large screens, cinematic vignette,
// overlaid caption and a neon crown stamp — every image carries the Speedy line-marking signature.
export const ShowcaseFigure = ({ src, alt, caption, natural = false, wide = true, position, testid }) => (
  <figure className={`my-14 ${wide ? "lg:-mr-24 xl:-mr-40" : ""}`} data-testid={testid}>
    <div className="group relative overflow-hidden rounded-xl ring-1 ring-white/10 shadow-[0_40px_90px_-30px_rgba(0,0,0,0.9)]">
      <img {...responsive(src, "(min-width: 1280px) 1120px, (min-width: 1024px) 900px, 100vw", WIDE_WIDTHS)} alt={alt} loading="lazy" decoding="async"
           style={position ? { objectPosition: position } : undefined}
           className={`w-full transition-transform duration-[1.6s] ease-out group-hover:scale-[1.025] ${natural ? "h-auto" : "h-[260px] md:h-[520px] object-cover"}`} />
      {!natural && <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-obsidian/85 via-obsidian/10 to-transparent" />}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 flex items-end justify-between gap-6 p-5 md:p-7">
        {!natural && caption && (
          <figcaption className="max-w-[70%] font-mono text-[10px] md:text-[11px] uppercase leading-relaxed tracking-[0.18em] text-zinc-200 drop-shadow">
            {caption}
          </figcaption>
        )}
        <span className={`ml-auto flex items-center gap-2 rounded-sm px-2.5 py-1.5 backdrop-blur-sm ${natural ? "bg-obsidian/70" : "bg-obsidian/40"}`}>
          <CrownMark className="h-5 md:h-6" animate={false} />
          <span className="hidden md:block font-mono text-[9px] uppercase tracking-[0.25em] text-gold">Speedy</span>
        </span>
      </div>
    </div>
    {natural && caption && <figcaption className="mt-3 font-mono text-[10px] uppercase tracking-widest text-zinc-500">{caption}</figcaption>}
  </figure>
);

export default ShowcaseFigure;
